import { makeStyles } from '@mui/styles'
import { Theme } from '../../../../../UI'

export default makeStyles((theme: Theme) => ({
    table: {
        maxWidth: '100% !important',
        overflowX: 'scroll'
    }
}))
